import { render, staticRenderFns } from "./Uploadexcel.vue?vue&type=template&id=ea4bc80e&scoped=true"
import script from "./Uploadexcel.vue?vue&type=script&lang=js"
export * from "./Uploadexcel.vue?vue&type=script&lang=js"
import style0 from "./Uploadexcel.vue?vue&type=style&index=0&id=ea4bc80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4bc80e",
  null
  
)

export default component.exports